// src/routes/PrivateLayout.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import { Private } from './Private'; // Caminho corrigido
import Layout from '../components/Layout/Layout'; // Caminho corrigido

const PrivateLayout = () => {
  return (
    <Private>
      <Layout>
        <Outlet />
      </Layout>
    </Private>
  );
};

export default PrivateLayout;

